import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPammService = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.25 5.58398C6.49406 6.28037 5.25 7.99359 5.25 10C5.25 12.0063 6.49423 13.7186 8.25 14.415V18.0596C4.53432 17.2574 1.75 13.9549 1.75 10C1.75 6.04492 4.53427 2.74066 8.25 1.93848V5.58398ZM16.2676 15.3584C15.1159 16.7041 13.5415 17.6718 11.75 18.0586V14.415C12.1572 14.2531 12.5353 14.0366 12.877 13.7754L16.2676 15.3584ZM11.75 1.93848C15.4657 2.74066 18.25 6.04492 18.25 10C18.25 10.7886 18.1369 11.5499 17.9297 12.2715L14.6885 10.7578C14.7283 10.5108 14.75 10.2577 14.75 10C14.75 7.99359 13.5059 6.28037 11.75 5.58398V1.93848Z",
		stroke: "",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgPammService;
